const BigHeading = ({ title }: { title: string }) => {
  return (
    <div className="w-full text-center relative flex items-center justify-center">
      <div className="absolute inset-0 flex items-center w-[90%] mx-auto pt-1">
        <div className="w-full border-b-2 border-dotted border-gray-300"></div>
      </div>
      <h2 className="text-4xl lg:text-5xl bg-white px-4 relative z-10">{title}</h2>
    </div>
  );
};

export default BigHeading;
